import axios from "axios";

export const refreshTabs = () => {
  const targets = [...document.querySelectorAll('[data-portal--submission-target="tabs"]')].filter((elem) => !elem.parentNode.hidden)
  for (let i = 0; i < targets.length; i++) {
    const tab = targets[i];
    tab.innerHTML = "" + (i + 1)
  }
}

export const showTab = (tabId) => {
  const tabElement = document.getElementById(tabId)
  tabElement.hidden = false;
}

export const hideTab = (tabId) => {
  const tabElement = document.getElementById(tabId)
  tabElement.hidden = true;
}

export const getPredefinedTestResultDefinitionsCount = async (accessionId, testScheduleIds) => {
  return axios({
    method: 'GET',
    url: "/portal/predefined_test_result_definitions_count.json",
    params: {
      accession_id: accessionId,
      test_schedule_ids: testScheduleIds
    }
  });
}

export const updatePredefinedTestResultTab = (accessionId, testScheduleIds) => {
  getPredefinedTestResultDefinitionsCount(accessionId, testScheduleIds)
    .then((res) => {
      if (res.data.count > 0) {
        showTab('predefined_test_results_tab_id')
      } else {
        hideTab('predefined_test_results_tab_id')
      }
      refreshTabs()
    })
}
